<template>
    <v-container class="grey lighten-5" fluid>
        <v-row align="center" justify="center">
            <v-col md="12" sm="12" xs="12">
                <v-card>
                    <v-card-title class="px-3">View Integrations</v-card-title>
                    <v-divider></v-divider>
                    <v-data-table
                        :headers="headers"
                        :items="integrations"
                        :items-per-page="10"
                        class="elevation-1"
                    >
                        <template v-slot:item.status="{ item }">
                            <v-icon v-if="item.status == 1" color="green" size="22">
                                mdi-check-circle
                            </v-icon>
                            <v-btn v-else :disabled="item.status == 1" @click="complete(item)" text icon color="grey">
                                <v-icon v-if="item.status == 0" color="red" size="22">
                                    mdi-progress-clock
                                </v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:item.gatewayOnly="{ item }">
                            <span v-if="item.gatewayOnly == 1">Yes</span>
                            <span v-else-if="item.gatewayOnly == 0">No</span>
                        </template>
                        <template v-slot:item.contact="{ item }">
                            {{ item.firstName }} {{ item.surname }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    beforeMount() {
        this.getIntegrations();
    },

    data() {
        return {
            integrations: [],
            headers: [{ text: 'Status', value: 'status', sortable: false, align: 'center' },
                      { text: 'Date Created', value: 'createdAt', sortable: false, align: 'left', width: 90 },
                      { text: 'Created By', value: 'createdByName', sortable: false, align: 'left', width: 90 },
                      { text: 'Date Completed', value: 'updatedAt', sortable: false, align: 'left', width: 90 },
                      { text: 'Completed By', value: 'completedByName', sortable: false, align: 'left', width: 90 },
                      { text: 'Sales Force ID', value: 'sf_id', sortable: false, align: 'left', width: 100 },
                      { text: 'Gateway Name', value: 'gatewayName', sortable: false, align: 'left', width: 100 },
                      { text: 'Acquirer', value: 'clearingInstitute', sortable: false, align: 'left', width: 120 },
                      { text: 'Platform', value: 'platform', sortable: false, align: 'left' },
                      { text: 'Sales Person', value: 'salesPerson', sortable: false, align: 'left', width: 120 },
                      { text: 'Partner', value: 'partner', sortable: false, align: 'left', width: 120 },
                      { text: 'Transaction Fee', value: 'transactionFee', sortable: false, align: 'center' },
                      { text: 'Service Fee', value: 'serviceFee', sortable: false, align: 'center' },
                      { text: 'Monthly Min.', value: 'monthlyMin', sortable: false, align: 'center' },
                      { text: 'VAT', value: 'vat', sortable: false, align: 'center' },
                      { text: 'Gateway Only', value: 'gatewayOnly', sortable: false, align: 'center' },
                      { text: 'Division', value: 'division', sortable: false, align: 'left' },
                      { text: 'Merchant', value: 'merchant', sortable: false, align: 'left' },
                      { text: 'Category', value: 'category', sortable: false, align: 'left' },
                      { text: 'Merchant ID', value: 'merchantId', sortable: false, align: 'left', width: 110 },
                      { text: 'Password', value: 'password', sortable: false, align: 'left', width: 90 },
                      { text: 'Store ID', value: 'storeId', sortable: false, align: 'left', width: 90 },
                      { text: 'MCC', value: 'mcc', sortable: false, align: 'left' },
                      { text: 'URL', value: 'url', sortable: false, align: 'left' },
                      { text: 'Address', value: 'address', sortable: false, align: 'left', width: 150 },
                      { text: 'Descriptor', value: 'descriptor', sortable: false, align: 'left' },
                      { text: 'Schemes', value: 'schemes', sortable: false, align: 'left' },
                      { text: 'Currencies', value: 'currencies', sortable: false, align: 'left' },
                      { text: 'Contact', value: 'contact', sortable: false, align: 'left', width: 120 },
                      { text: 'Email', value: 'email', sortable: false, align: 'left' },
                      { text: 'Recurring', value: 'recType', sortable: false, align: 'left', width: 110 },
                      { text: '3D Secure', value: 'threeDSecure', sortable: false, align: 'left', width: 110 }],
        }
    },
    methods: {
        getIntegrations() {
            axios({
                method: 'get',
                url: `get-integrations`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.integrations = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        complete(e) {
            axios({
                method: 'post',
                url: `complete-integration`,
                data: { id: e.id, userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    console.log(response.data);
                    console.log(e);

                    e.status = response.data.status;
                    e.updatedAt = response.data.updatedAt;
                })
                .catch(e => {
                    this.errors.push(e)
            })
        }
    }
}
</script>

<style>
.v-select.v-input--dense .v-chip {
    margin: 4px 4px 4px 4px !important;
}
</style>